module.exports = __webpack_public_path__ + "img/unlock.1b239036.svg";